import { ModalConfirmProps } from '../../../components/common/hd-modal/types';

class ModalController {
  private static instance: ModalController;

  private confirmFn: ((props: ModalConfirmProps) => Promise<boolean>) | null =
    null;

  public setConfirmFn(
    fn: (props: ModalConfirmProps) => Promise<boolean>,
  ): void {
    this.confirmFn = fn;
  }

  static getInstance(): ModalController {
    if (!ModalController.instance) {
      ModalController.instance = new ModalController();
    }
    return ModalController.instance;
  }

  public async confirm(props: ModalConfirmProps): Promise<boolean> {
    if (!this.confirmFn) {
      throw new Error('[ModalController] ModalProvider not mounted.');
    }
    return this.confirmFn(props);
  }
}

// Export a singleton instance
export default ModalController;
